import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/config-page/config-page.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StructuredContentWrapper"] */ "/app/app/lib/structured-content/structured-content.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
